import React, { FC, useRef } from "react";
import type { UniversalPaymentAccountPreventingFraudProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";

export const UniversalPaymentAccountPreventingFraud: FC<UniversalPaymentAccountPreventingFraudProps> = ({
  title,
  description,
  image,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="universalPaymentAccountPreventingFraud">
      <div className="universalPaymentAccountPreventingFraud--inner">
        <div className="universalPaymentAccountPreventingFraud--content">
          {image?.file?.url && (
            <Image
              className="universalPaymentAccountPreventingFraud--image"
              src={image as any}
              alt={image.title}
              options={{
                sizes: {
                  exec: [
                    {
                      width: 704,
                      height: 671,
                    },
                  ],
                },
              }}
              animateInView
            />
          )}
          <div className="universalPaymentAccountPreventingFraud--text" ref={ref}>
            {title && (
              <ContentManager
                content={title}
                className="universalPaymentAccountPreventingFraud--title"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
            {description && (
              <ContentManager
                content={description}
                className="universalPaymentAccountPreventingFraud--description"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
